// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1pBEo","bigColWidth":"Table_bigColWidth__1eoev","biggerColWidth":"Table_biggerColWidth__1Zq4Y","row":"Table_row__3nNdx","col":"Table_col__3CZNl"};